import { render, staticRenderFns } from "./NewGallery.vue?vue&type=template&id=494e7b91&"
import script from "./NewGallery.vue?vue&type=script&lang=js&"
export * from "./NewGallery.vue?vue&type=script&lang=js&"
import style0 from "./NewGallery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports